<div class="recruitment" id="recruitment">
  <div class="container">
    <div>
      <h2 class="recruitment__section-title">Recruitment process</h2>
      <div class="recruitment__process">
        <span class="recruitment__process-line">
          <span class="recruitment__process-arrow"></span>
        </span>
        <div
          class="recruitment__process-step"
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="300"
        >
          <span class="recruitment__process-dott-md"></span>
          <img
            class="recruitment__process-icon"
            ngSrc="../../../../assets/recruitment/online-app.svg"
            width="60"
            height="60"
            alt="process icon"
          />
          <div class="recruitment__process-point">
            <span class="recruitment__process-dott"></span>
            <p
              class="recruitment__process-text recruitment__process-text--wrapped display display-5b"
            >
              1.Online application
            </p>
          </div>
        </div>
        <div
          class="recruitment__process-step"
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="300"
        >
          <span class="recruitment__process-dott-md"></span>
          <img
            class="recruitment__process-icon"
            ngSrc="../../../../assets/recruitment/phone-call.svg"
            width="60"
            height="60"
            alt="process icon"
          />
          <div class="recruitment__process-point">
            <span class="recruitment__process-dott"></span>
            <p class="recruitment__process-text display display-5b">
              2.Phone call
            </p>
          </div>
        </div>
        <div
          class="recruitment__process-step"
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="300"
        >
          <span class="recruitment__process-dott-md"></span>
          <img
            class="recruitment__process-icon"
            ngSrc="../../../../assets/recruitment/interview.svg"
            width="60"
            height="60"
            alt="process icon"
          />
          <div class="recruitment__process-point">
            <span class="recruitment__process-dott"></span>
            <p class="recruitment__process-text display display-5b">
              3.Online recruitment interview with HR
            </p>
          </div>
        </div>
        <div
          class="recruitment__process-step"
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="300"
        >
          <span class="recruitment__process-dott-md"></span>
          <img
            class="recruitment__process-icon"
            ngSrc="../../../../assets/recruitment/techical-interv.svg"
            width="60"
            height="60"
            alt="process icon"
          />
          <div class="recruitment__process-point">
            <span class="recruitment__process-dott"></span>
            <p class="recruitment__process-text display display-5b">
              4.Online technical interview with TL
            </p>
          </div>
        </div>
        <div
          class="recruitment__process-step"
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="300"
        >
          <span class="recruitment__process-dott-md"></span>
          <img
            class="recruitment__process-icon"
            ngSrc="../../../../assets/recruitment/offer.svg"
            width="60"
            height="60"
            alt="process icon"
          />
          <div class="recruitment__process-point">
            <span class="recruitment__process-dott"></span>
            <p class="recruitment__process-text display display-5b">5.Offer</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
